<!-- Tabs -->
<ul class="nav nav-pills nav-tab-code-render" role="tablist">
  <li *ngIf="data['html']" class="nav-item nav-item-code-render" role="presentation">
    <button 
    class="nav-link nav-link-code-render active" [id]="'pills-var-html-tab-' + idComponent"
      data-bs-toggle="pill" [attr.data-bs-target]="'#pills-var-html-' + idComponent" type="button" role="tab"
      [attr.aria-controls]="'pills-var-html-tab-' + idComponent" 
      aria-selected="true">HTML</button>
  </li>
  <li *ngIf="data['css']" class="nav-item nav-item-code-render" role="presentation">
    <button class="nav-link nav-link-code-render" [id]="'pills-var-css-tab-' + idComponent" 
      data-bs-toggle="pill" [attr.data-bs-target]="'#pills-var-css-' + idComponent" type="button" role="tab" 
      [attr.aria-controls]="'pills-var-css-tab-' + idComponent"
      aria-selected="false">CSS</button>
  </li>
  <li *ngIf="data['js']" class="nav-item nav-item-code-render" role="presentation">
    <button class="nav-link nav-link-code-render" [id]="'pills-var-js-tab-' + idComponent" 
      data-bs-toggle="pill" [attr.data-bs-target]="'#pills-var-js-' + idComponent" type="button" role="tab" 
      [attr.aria-controls]="'pills-var-js-tab-' + idComponent"
      aria-selected="false">JS</button>
  </li>
</ul>

<!-- CodeRender -->
<div class="tab-content">
  <div *ngIf="data['html']" class="tab-pane fade show active" [id]="'pills-var-html-' + idComponent" role="tabpanel"
    [attr.aria-labelledby]="'pills-var-html-tab-' + idComponent">
    <app-code-render [code]="data['html']" [language]="'html'"></app-code-render>
  </div>
  <div *ngIf="data['css']" class="tab-pane fade" [id]="'pills-var-css-' + idComponent" role="tabpanel"
    [attr.aria-labelledby]="'pills-var-css-tab-' + idComponent">
    <app-code-render [code]="data['css']" [language]="'css'"></app-code-render>
  </div>
  <div *ngIf="data['js']" class="tab-pane fade" [id]="'pills-var-js-' + idComponent" role="tabpanel"
    [attr.aria-labelledby]="'pills-var-js-tab-' + idComponent">
    <app-code-render [code]="data['js']" [language]="'js'"></app-code-render>
  </div>
</div>